module.exports = __webpack_public_path__ + "static/media/banner-apple-non-ppfa.151cf846.png";